<template>

  <div>
    <v-container v-if="insureType === 'searchPlot'" class="pa-0">
      <div class="insure-section mb-2">
        <div class="d-flex align-center justify-space-between mb-1">
          <div class="insure-section__title">地块搜索</div>
          <div class="d-flex align-center">
            <v-btn small color="primary" @click="goToPlotDraw">画地块</v-btn>
            <v-text-field v-model="coordInput" dense solo flat hide-details placeholder="经度,纬度" class="mr-2"
              style="width: 160px; font-size: 13px;" @keyup.enter="locateByCoord" />
            <v-btn small color="primary" depressed :disabled="!coordInput" @click="locateByCoord">
              定位
            </v-btn>
          </div>
        </div>
        <v-divider class="mb-2"></v-divider>
        <v-row dense class="align-center mt-1">
          <v-col cols="5">
            <v-combobox v-model="personName" :items="persons" :loading="searchLoading" :search-input.sync="searchQuery"
              label="农户姓名" color="grey darken-1" :rules="[v => !!v || '姓名不能为空']" dense clearable
              :item-text="formatPersonDisplay" @update:search-input="searchPersons" @change="onPersonSelected"
              @keypress.enter="selectPlot" />
          </v-col>
          <v-col cols="7" class="d-flex justify-end align-center flex-nowrap">
            <v-btn x-small color="primary" class="mr-1" @click="selectPlot">搜索</v-btn>
            <v-btn x-small color="secondary" class="mr-1" @click="$emit('request-box-select-add')">
              框选添加
            </v-btn>
            <v-btn x-small color="success" :disabled="addableSearchPlotsCount === 0"
              @click="addAllPlotsToCart">
              全部添加
            </v-btn>
            <v-btn x-small color="error" class="ml-1" :disabled="landData.length === 0" @click="removeAllSearchPlots">
              全部移除
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table ref="plotDataTable" :headers="searchHeaders" :items="landData" :items-per-page="-1" class="mt-2"
          :loading="loading" loading-text="加载中..." no-data-text="暂无数据" dense fixed-header hide-default-footer
          height="33vh">
          <template v-slot:item.qsrxm="{ item }">
            {{ displayOwnerName(item) }}
          </template>
          <template v-slot:item.qsrid="{ item }">
            {{ displayOwnerIdCard(item) }}
          </template>
          <template v-slot:item.owner_name="{ item }">
            {{ displayOwnerName(item) }}
          </template>
          <template v-slot:item.bs="{ item }">
            <span v-if="isInsured(item)" class="insured-status">是</span>
            <span v-else>否</span>
          </template>
          <template v-slot:item.area_mu="{ item }">
            {{ Number(item.area_mu || 0).toFixed(2) }}
          </template>
          <template v-slot:item.mj="{ item }">
            {{ Number(item.mj || item.area_mu || 0).toFixed(2) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn x-small color="primary" class="mr-2" @click="viewSelectedLand(item)">查看</v-btn>
              <v-btn x-small color="success" class="mr-2" :disabled="isInsured(item) || isInCart(item)"
                @click="addPlotToCart(item)">
                添加
              </v-btn>
              <v-btn x-small color="error" @click="removeFromSearchList(item)">删除</v-btn>
            </div>
          </template>
        </v-data-table>
      </div>

      <div class="insure-section">
        <div class="d-flex align-center justify-space-between mb-1">
          <div class="insure-section__title">投保地块</div>
          <div class="d-flex align-center">
            <div class="text-caption grey--text mr-2">已选: {{ selectedTotalArea }} 亩</div>
            <v-btn small text color="error" class="mr-2" :disabled="selected.length === 0" @click="removeAllFromCart">
              全部移除
            </v-btn>
            <v-btn small color="primary" :disabled="selected.length === 0" @click="createPolicy">投保</v-btn>
          </div>
        </div>
        <v-data-table :headers="selectedHeaders" :items="selected" :items-per-page="-1" class="mt-1"
          no-data-text="暂无已选地块" dense fixed-header hide-default-footer height="25vh">
          <template v-slot:item.owner_name="{ item }">
            {{ displayOwnerName(item) }}
          </template>
          <template v-slot:item.area_mu="{ item }">
            {{ Number(item.area_mu || 0).toFixed(2) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn x-small color="primary" class="mr-2" @click="viewSelectedLand(item)">查看</v-btn>
              <v-btn x-small color="error" @click="removeFromCart(item)">移除</v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-container>

    <v-container v-if="insureType === 'markedPlot'">
      <v-row dense>
        <v-col cols="12" class="text-right pb-0">
          <v-btn small color="primary" @click="backToInsureApply">返回投保模式</v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="area" label="面积(亩)" readonly color="grey darken-1" dense></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="parcelName" label="地块名称" color="grey darken-1" :rules="[v => !!v || '地块名称不能为空']"
            dense></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field v-model="ownerName" label="所属人姓名" color="grey darken-1" :rules="[v => !!v || '所属人姓名不能为空']"
            dense></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="ownerId" label="所属人身份证号" color="grey darken-1"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn @click="createLand">提交</v-btn>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbar" class="centered-snackbar">
      {{ notifyText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog ref="createPolicyDialog" v-model="policyDialog" persistent :max-width="policyDialogMaxWidth">
      <v-card>
        <v-card-title class="text-subtitle-1 pb-2 d-flex align-center">
          <span>保单信息填写</span>
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">所属地区：{{ selectedArea?.display_name || selectedArea?.name || '' }}</span>
        </v-card-title>
        <v-form class="px-6" ref="policyForm">
          <v-row dense class="align-start">
            <v-col cols="4" class="pt-0">
              <div class="d-flex align-center justify-space-between mb-0 policy-row-field-label">
                <span>保单号</span>
                <span v-if="showMatchedPolicyHint" class="text-caption info--text policy-number-hint-inline">
                  将沿用已匹配保单号：{{ policyForm.bdh }}
                </span>
              </div>
              <v-text-field
                dense
                hide-details
                class="mt-0 policy-row-control"
                v-model="policyForm.bdh"
                placeholder="未匹配时系统自动生成"
                readonly
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <div class="text-caption grey--text mb-0 policy-row-field-label">处理方式</div>
              <div class="d-flex flex-wrap align-center policy-row-control policy-mode-options">
                <v-checkbox
                  v-for="option in applyModeOptions"
                  :key="option.value"
                  :input-value="policyForm.applyMode === option.value"
                  :label="option.text"
                  hide-details
                  dense
                  class="mt-0 mr-3"
                  @change="onApplyModeChange(option.value)"
                />
              </div>
            </v-col>
            <v-col cols="2" class="text-right pt-0 d-flex justify-end align-start">
              <v-btn small text :loading="matchLoading" @click="matchPolicyInfo">匹配保单</v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="4">
              <v-text-field dense v-model="policyForm.holderName" label="被保险人姓名" :rules="[v => !!v || '请输入被保险人姓名']" />
            </v-col>
            <v-col cols="4">
              <v-text-field dense v-model="policyForm.holderId" label="身份证号" :rules="idCardValidationRules"
                @input="normalizeIdCard" />
            </v-col>
            <v-col cols="4">
              <div class="d-flex align-center">
                <v-text-field dense hide-details v-model="policyForm.phone_number" label="联系方式" class="mr-3" />
                <v-checkbox v-model="policyForm.isLargeFarmer" label="大户" hide-details class="mt-0 mb-0" />
              </div>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="4">
              <v-select dense label="作物类型" v-model="policyForm.crop_id" :items="authorizedCrops" item-text="text"
                item-value="value" :rules="[v => !!v || '请选择作物类型']" />
            </v-col>
            <v-col cols="4">
              <v-text-field dense v-model="policyForm.tbmj" :label="isAppendMode ? '本次追加面积(亩)' : '投保面积(亩)'"
                :rules="areaRules" />
            </v-col>
          </v-row>

          <v-row dense v-if="isAppendMode">
            <v-col cols="3">
              <v-text-field dense :value="matchedPolicyAreaDisplay" label="原投保面积(亩)" readonly />
            </v-col>
            <v-col cols="3">
              <v-text-field dense :value="appendTotalAreaDisplay" label="追加后总面积(亩)" readonly />
            </v-col>
          </v-row>

          <div class="text-subtitle-2 mt-2 mb-1">数据展示</div>
          <v-row dense>
            <v-col cols="4">地块面积：{{ selectedTotalArea }} 亩</v-col>
            <v-col cols="4">误差率：{{ errorRateDisplay }}</v-col>
          </v-row>
        </v-form>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelPolicy">取消</v-btn>
          <v-btn color="green darken-1" text :loading="policySubmitting" @click="policyConfirm">提交保单</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="matchCandidateDialog" max-width="900px">
      <v-card>
        <v-card-title class="text-subtitle-1 pb-2">请选择匹配保单</v-card-title>
        <v-card-text class="pt-2">
          <v-data-table :headers="matchCandidateHeaders" :items="matchCandidates" :items-per-page="-1" dense
            hide-default-footer no-data-text="暂无候选保单">
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="primary" @click="selectMatchedPolicy(item)">选择</v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green darken-1" @click="matchCandidateDialog = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LineStringGeom from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { getArea, getLength } from 'ol/sphere.js';
import axios from '@/axios';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { GeoJSON } from 'ol/format';
import { Fill, Stroke, Style, Circle as CircleStyle } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import { Mapable } from '../../mixins/Mapable';
import { mapState, mapGetters } from 'vuex';
import { useInsureApplyStore } from '@/stores/insureApply';
import { idCardRules } from '../../util/Validate.js';
import {
  AREA_DEVIATION_BLOCK_TEMPLATE,
  MAX_AREA_ERROR_RATE_PERCENT
} from '@/constants/insuranceRules';

const EMPTY_RESULT_TEXT = ' -- ';

export default {
  name: 'wgu-measure-result',
  mixins: [Mapable],
  props: {
    measureGeom: { type: Object },
    insureType: { type: String },
    trusteeLands: { type: Array },
    clickedPlotInfo: { type: Object, default: null }
  },
  data () {
    return {
      idCardValidationRules: idCardRules(), // Call the function to get the rules array
      area: EMPTY_RESULT_TEXT,
      distance: EMPTY_RESULT_TEXT,
      angle: EMPTY_RESULT_TEXT,
      personName: '',
      parcelName: '',
      ownerName: '',
      ownerId: '',
      polygon: null,
      snackbar: false,
      notifyText: '',
      searchHeaders: [
        { text: '地块ID', value: 'land_id' },
        { text: '地块名称', value: 'dkmc' },
        { text: '地类', value: 'DL' },
        { text: '权属人', value: 'qsrxm' },
        { text: '身份证号', value: 'qsrid' },
        { text: '面积(亩)', value: 'mj' },
        { text: '投保', value: 'bs' },
        { text: '操作', value: 'actions' }
      ],
      selectedHeaders: [
        { text: '地块ID', value: 'land_id' },
        { text: '地块名称', value: 'land_name' },
        { text: '农户姓名', value: 'owner_name' },
        { text: '面积(亩)', value: 'area_mu' },
        { text: '操作', value: 'actions' }
      ],
      landData: [], // Current search results
      loading: false,
      selected: [],
      showMapSelection: false,
      singleSelect: false,
      policyDialog: false,
      policySubmitting: false,
      matchLoading: false,
      matchCandidateDialog: false,
      matchCandidates: [],
      matchCandidateHeaders: [
        { text: '保单号', value: 'bdh' },
        { text: '被保险人', value: 'qsrmc' },
        { text: '身份证号', value: 'nhdm_masked' },
        { text: '联系方式', value: 'phone' },
        { text: '投保面积(亩)', value: 'tbmj' },
        { text: '操作', value: 'actions', sortable: false }
      ],
      policyForm: {
        bdh: '',
        holderName: '',
        holderId: '',
        crop_id: null,
        phone_number: '',
        tbmj: '',
        applyMode: '',
        isLargeFarmer: false,
        selectedPolicyId: null
      },
      matchedPolicyArea: 0,
      persons: [],
      searchQuery: null,
      searchLoading: false,
      searchTimeout: null,
      areaRules: [
        v => !!v || '请输入投保面积',
        v => Number(v) > 0 || '投保面积必须大于0'
      ],
      selectedVectorSource: new VectorSource(),
      polygonStyleFunction: () => {
        return new Style({
          stroke: new Stroke({
            color: '#FF0000',
            width: 4,
            lineDash: [10, 5]
          }),
          fill: new Fill({
            color: 'rgba(255, 0, 0, 0.35)'
          })
        });
      },
      coordInput: '',
      blinkTimer: null,
      locateSeq: 0
    }
  },
  computed: {
    ...mapState(['authorizedArea']),
    ...mapGetters(['getCodesByType']),
    insureApplyStore () {
      return useInsureApplyStore();
    },
    selectedLandPlots () {
      return this.insureApplyStore.selectedLandPlots;
    },
    insureApplyState () {
      return this.insureApplyStore.insureApplyState;
    },
    sessionScopeKey () {
      const userId = this.getCurrentUserId() || 'anonymous'
      const areaCode = this.getCurrentAreaCode() || 'no-area'
      return `${userId}::${areaCode}`
    },
    authorizedCrops () {
      // Backend returns CROP codes from /codes/?type=CROP
      return this.getCodesByType('CROP');
    },
    selectedArea () {
      return this.$store.state.selectedArea;
    },
    selectedTotalArea () {
      return this.selected.reduce((sum, item) => sum + Number(item.area_mu || 0), 0).toFixed(2);
    },
    addableSearchPlotsCount () {
      return this.landData.filter(item => !this.isInsured(item) && !this.isInCart(item)).length;
    },
    applyModeOptions () {
      // 处理方式选项显示为三种；匹配后未手选时按默认方式（matched）提交。
      return [
        { text: '新增', value: 'new' },
        { text: '追加', value: 'append' },
        { text: '替换', value: 'replace' }
      ];
    },
    isAppendMode () {
      return this.policyForm.applyMode === 'append';
    },
    isReplaceMode () {
      return this.policyForm.applyMode === 'replace';
    },
    hasMatchedPolicy () {
      return !!this.policyForm.selectedPolicyId && !!this.policyForm.bdh;
    },
    isNewModeWithMatchedPolicy () {
      return this.policyForm.applyMode === 'new' && this.hasMatchedPolicy;
    },
    showMatchedPolicyHint () {
      return this.hasMatchedPolicy;
    },
    errorRate () {
      const insuredArea = Number(this.policyForm.tbmj);
      if (!insuredArea || insuredArea <= 0) return null;
      const diff = (Number(this.selectedTotalArea) - insuredArea) / insuredArea * 100;
      return Number.isNaN(diff) ? null : diff;
    },
    errorRateDisplay () {
      if (this.errorRate === null) return '--';
      return `${this.errorRate.toFixed(2)}%`;
    },
    selectedCropText () {
      const crop = this.authorizedCrops.find(item => item.value === this.policyForm.crop_id);
      return crop ? crop.text : '';
    },
    matchedPolicyAreaDisplay () {
      return Number(this.matchedPolicyArea || 0).toFixed(2);
    },
    appendTotalAreaDisplay () {
      const total = Number(this.matchedPolicyArea || 0) + Number(this.policyForm.tbmj || 0);
      return Number.isNaN(total) ? '--' : total.toFixed(2);
    },
    policyDialogMaxWidth () {
      const breakpoint = this.$vuetify?.breakpoint;
      if (!breakpoint) return '80%';
      if (breakpoint.smAndDown) return '95%';
      if (breakpoint.mdOnly) return '85%';
      return '80%';
    }
  },
  beforeDestroy () {
    this.persistInsureApplyState();
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    if (this.blinkTimer) {
      clearInterval(this.blinkTimer);
      this.blinkTimer = null;
    }
  },
  watch: {
    measureGeom () {
      const me = this;
      const geom = me.measureGeom.geom;
      let output;
      if (geom && this.insureType === 'markedPlot') {
        output = me.formatArea(geom);
        me.area = output;

        // perimeter of outer LinearRing of measure polygon
        me.distance = me.formatLength(new LineStringGeom(
          geom.getLinearRing(0).getCoordinates()
        ));
      } else if (geom && this.measureType === 'distance') {
        output = me.formatLength(geom);
        me.distance = output;
      } else if (geom && this.measureType === 'angle') {
        me.angle = me.formatAngle(geom);
      } else {
        me.area = EMPTY_RESULT_TEXT;
        me.distance = EMPTY_RESULT_TEXT;
        me.angle = EMPTY_RESULT_TEXT;
      }
    },
    trusteeLands: {
      deep: true,
      handler (newVal) {
        this.syncMapSelectionToSearchList(newVal || []);
      }
    },
    selectedLandPlots (newVal) {
      console.log('Land plots from map updated:', newVal);
      this.updateSelectedPlotsFromMap();
    },
    sessionScopeKey (newVal, oldVal) {
      if (!oldVal) return;
      if (newVal !== oldVal) {
        this.resetSearchState();
      }
    }
  },
  methods: {
    getCurrentUserId () {
      const user = this.$store?.state?.user
      return user?.id || user?.user_id || user?.username || user?.email || null
    },
    getCurrentAreaCode () {
      return this.selectedArea?.place_id || this.selectedArea?.code || null;
    },
    buildInsureApplyState () {
      return {
        version: 1,
        savedAt: Date.now(),
        userId: this.getCurrentUserId(),
        areaCode: this.getCurrentAreaCode(),
        fromRoute: this.$route?.path || '/insure-apply',
        toRoute: null,
        personName: this.personName,
        searchQuery: this.searchQuery,
        persons: Array.isArray(this.persons) ? this.persons : [],
        landData: Array.isArray(this.landData) ? this.landData : [],
        loading: !!this.loading,
        selected: Array.isArray(this.selected) ? this.selected : [],
        policyForm: { ...this.policyForm },
        matchedPolicyArea: this.matchedPolicyArea,
        policyDialog: !!this.policyDialog,
        matchCandidates: Array.isArray(this.matchCandidates) ? this.matchCandidates : [],
        matchCandidateDialog: !!this.matchCandidateDialog,
        coordInput: this.coordInput || ''
      };
    },
    persistInsureApplyState (extra = {}) {
      if (this.insureType !== 'searchPlot') return;
      const payload = {
        ...this.buildInsureApplyState(),
        ...extra
      };
      this.insureApplyStore.setInsureApplyState(payload);
    },
    restoreInsureApplyState () {
      if (this.insureType !== 'searchPlot') return;

      const saved = this.insureApplyState;
      if (!saved || typeof saved !== 'object') return;

      // Drop legacy cache payloads written before user-scoped isolation.
      if (!saved.userId) {
        this.insureApplyStore.clearInsureApplyState();
        return;
      }

      const currentUserId = this.getCurrentUserId();
      if (saved.userId) {
        if (!currentUserId || saved.userId !== currentUserId) {
          return;
        }
      }

      const currentAreaCode = this.getCurrentAreaCode();
      if (saved.areaCode && saved.areaCode !== currentAreaCode) {
        return;
      }

      this.personName = saved.personName ?? this.personName;
      this.searchQuery = saved.searchQuery ?? this.searchQuery;
      this.persons = Array.isArray(saved.persons) ? saved.persons : [];
      this.landData = Array.isArray(saved.landData) ? saved.landData : [];
      this.loading = !!saved.loading;
      this.selected = Array.isArray(saved.selected) ? saved.selected : [];
      this.policyForm = {
        ...this.policyForm,
        ...(saved.policyForm && typeof saved.policyForm === 'object' ? saved.policyForm : {})
      };
      this.policyForm.applyMode = this.normalizeApplyMode(this.policyForm.applyMode);
      this.matchedPolicyArea = Number(saved.matchedPolicyArea || 0);
      this.policyDialog = !!saved.policyDialog;
      this.matchCandidates = Array.isArray(saved.matchCandidates) ? saved.matchCandidates : [];
      this.matchCandidateDialog = !!saved.matchCandidateDialog;
      this.coordInput = saved.coordInput || '';
    },
    resetSearchState () {
      this.personName = '';
      this.searchQuery = null;
      this.persons = [];
      this.landData = [];
      this.loading = false;
      this.selected = [];
      this.policyDialog = false;
      this.matchLoading = false;
      this.matchCandidateDialog = false;
      this.matchCandidates = [];
      this.coordInput = '';
      this.matchedPolicyArea = 0;
      this.policyForm = {
        bdh: '',
        holderName: '',
        holderId: '',
        crop_id: null,
        phone_number: '',
        tbmj: '',
        applyMode: '',
        isLargeFarmer: false,
        selectedPolicyId: null
      };

      this.insureApplyStore.clearSelectedLandPlots();
      this.insureApplyStore.clearInsureApplyState();
    },
    async searchPersons (val) {
      if (!val || val.length < 1) return;
      if (!this.selectedArea?.place_id) {
        this.notifyText = '请先选择区域';
        this.snackbar = true;
        return;
      }

      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(async () => {
        this.searchLoading = true;
        try {
          const response = await axios.get('/plots/persons', {
            params: {
              limit: 100,
              name: val,
              village_code: this.selectedArea?.place_id
            }
          });

          if (response.data && response.data.data) {
            this.persons = response.data.data;
          }
        } catch (error) {
          console.error('搜索人员失败:', error);
          this.notifyText = '搜索人员失败';
          this.snackbar = true;
        } finally {
          this.searchLoading = false;
        }
      }, 300);
    },
    formatPersonDisplay (item) {
      if (item && item.name) {
        const displayId = item.id_number || item.id_number_raw;
        if (displayId) {
          if (String(displayId).includes('*')) {
            return `${item.name} - ${displayId}`;
          }
          return `${item.name} - *${String(displayId).slice(-5)}`;
        }
        return item.name;
      }
      return '';
    },
    getSelectedPersonName () {
      if (this.personName && typeof this.personName === 'object') {
        return this.personName.name || '';
      }
      if (typeof this.personName === 'string') {
        return this.personName.trim();
      }
      return '';
    },
    getSelectedPersonId () {
      if (this.personName && typeof this.personName === 'object') {
        return this.personName.id_number_raw || this.personName.id_number || '';
      }
      return '';
    },
    normalizePlot (item) {
      const plotId = item.plot_id || item.id || null;
      const dkmc = item.dkmc || item.land_name || item.parcelName || '';
      const DL = item.DL || item.land_type || '';
      const qsrxm = item.qsrxm || item.qsrmc || item.owner_name || item.ownerName || this.getSelectedPersonName() || '';
      const mj = Number(item.mj || item.area_mu || item.htmj || 0);
      return {
        ...item,
        plot_id: plotId,
        land_id: item.land_id || item.dkbm || plotId,
        land_name: dkmc,
        owner_name: qsrxm,
        land_type: DL,
        area_mu: mj,
        dkmc,
        DL,
        qsrxm,
        mj,
        qsrid: this.extractOwnerIdCard(item)
      };
    },
    extractOwnerIdCard (item) {
      const rawValue = item?.qsrid ||
        item?.owner_id_card ||
        item?.person_id ||
        item?.nhdm ||
        item?.id_number_raw ||
        item?.id_number ||
        item?.ownerId ||
        item?.owner_id ||
        '';
      return String(rawValue || '').trim();
    },
    maskIdCard (value) {
      const idCard = String(value || '').trim();
      if (!idCard) return '';
      if (idCard.includes('*')) return idCard;
      if (idCard.length <= 4) return `*${idCard}`;
      return `${'*'.repeat(idCard.length - 4)}${idCard.slice(-4)}`;
    },
    displayOwnerName (item) {
      return item.owner_name || item.qsrxm || item.qsrmc || item.ownerName || this.getSelectedPersonName() || '';
    },
    displayOwnerIdCard (item) {
      return this.maskIdCard(this.extractOwnerIdCard(item));
    },
    isInCart (item) {
      const plotId = item.plot_id || item.id;
      return this.selected.some(sel => (sel.plot_id || sel.id) === plotId || sel.land_id === item.land_id);
    },
    addPlotToCart (item) {
      if (this.isInsured(item) || this.isInCart(item)) return;
      this.selected.push(this.normalizePlot(item));
    },
    addAllPlotsToCart () {
      if (!this.landData.length) {
        this.notifyText = '暂无可添加地块';
        this.snackbar = true;
        return;
      }

      const addablePlots = this.landData.filter(item => !this.isInsured(item) && !this.isInCart(item));
      if (!addablePlots.length) {
        this.notifyText = '搜索结果已全部在投保列表或已投保';
        this.snackbar = true;
        return;
      }

      addablePlots.forEach(item => {
        this.selected.push(this.normalizePlot(item));
      });

      this.notifyText = `已添加 ${addablePlots.length} 个地块到投保列表`;
      this.snackbar = true;
    },
    removeFromCart (item) {
      const plotId = item.plot_id || item.id;
      this.selected = this.selected.filter(sel => (sel.plot_id || sel.id) !== plotId && sel.land_id !== item.land_id);

      const updatedPlots = this.selectedLandPlots.filter(plot => plot.land_id !== item.land_id);
      this.insureApplyStore.clearSelectedLandPlots();
      updatedPlots.forEach(plot => {
        this.insureApplyStore.addSelectedLandPlot(plot);
      });

      this.$emit('remove-trustee-land', item);
    },
    removeAllFromCart () {
      if (!this.selected.length) return;

      const removedPlots = [...this.selected];
      this.selected = [];
      this.insureApplyStore.clearSelectedLandPlots();
      removedPlots.forEach(plot => {
        this.$emit('remove-trustee-land', plot);
      });

      this.notifyText = `已移除 ${removedPlots.length} 个投保地块`;
      this.snackbar = true;
    },
    removeAllSearchPlots () {
      if (!this.landData.length) return;

      this.landData = [];
      this.$emit('refreshTrusteeLands');
      this.notifyText = '搜索列表已清空';
      this.snackbar = true;
    },
    removeFromSearchList (item) {
      const plotId = item.plot_id || item.id;
      this.landData = this.landData.filter(row => {
        const rowPlotId = row.plot_id || row.id;
        return rowPlotId !== plotId && row.land_id !== item.land_id;
      });

      this.$emit('remove-trustee-land', item);
    },
    normalizeIdCard (value) {
      if (!value) return;
      this.policyForm.holderId = String(value).toUpperCase();
    },
    normalizeApplyMode (mode) {
      const normalizedMode = String(mode || '').toLowerCase();
      const availableModes = this.applyModeOptions.map(option => option.value);
      return availableModes.includes(normalizedMode) ? normalizedMode : '';
    },
    onApplyModeChange (mode) {
      const previousMode = this.policyForm.applyMode;
      this.policyForm.applyMode = this.normalizeApplyMode(mode);

      const matchedAreaText = this.matchedPolicyArea > 0 ? String(this.matchedPolicyArea) : '';
      const currentAreaText = String(this.policyForm.tbmj || '');

      // 切到追加模式时，避免将原保单面积误当作“本次追加面积”。
      if (this.policyForm.applyMode === 'append') {
        if (currentAreaText === matchedAreaText) {
          this.policyForm.tbmj = '';
        }
        return;
      }

      // 从追加切回非追加模式时，如已匹配保单且未填写面积，则回填原投保面积。
      if (previousMode === 'append' && this.policyForm.selectedPolicyId && !currentAreaText) {
        this.policyForm.tbmj = matchedAreaText;
      }
    },
    syncMapSelectionToSearchList (plots) {
      plots.forEach(plot => {
        const normalized = this.normalizePlot({ ...plot, fromMap: true });
        const existsInSearch = this.landData.some(item => item.land_id === normalized.land_id);
        if (!existsInSearch) {
          this.landData.unshift(normalized);
        }
      });
    },
    /**
       * Calculates and formats the length of the given line.
       *
       * @param  {ol.geom.LineString} line The LineString object to calculate length for
       */
    formatLength (line) {
      const length = getLength(line);
      let output;
      if (length > 100) {
        output = this.$t('wgu-measuretool.lengthKm',
          [Math.round(length / 1000 * 100) / 100]);
      } else {
        output = this.$t('wgu-measuretool.lengthMeter',
          [Math.round(length * 100) / 100]);
      }
      return output;
    },
    /**
       * Calculates and formats the area of the given polygon.
       *
       * @param  {ol.geom.Polygon} polygon The Polygon object to calculate area for
       */
    formatArea (polygon) {
      const area = getArea(polygon.transform('EPSG:4326', 'EPSG:3857'));
      const output = (area / 666.6667).toFixed(1);
      return output;
    },
    // TODO: if the owner name and id is in the system, and diif from the input, show a warning.
    /**
       * Creates a new land plot with the given information.
       */
    async createLand () {
      if (typeof this.measureGeom.geom.flatCoordinates === 'undefined') {
        this.$notify({
          title: 'ERROR!',
          text: '请先测量！'
        });
        console.log('属性不存在');
      }

      const plotInfo = {
        plotName: this.parcelName,
        plotOwnerName: this.ownerName,
        plotOwnerId: this.ownerId,
        plotArea: this.area,
        plotPolygon: this.measureGeom.geom.flatCoordinates,
        villageCode: this.selectedArea.place_id
      };
      this.submitLand(plotInfo);
    },
    async submitLand (plotInfo) {
      // Validate the data before submitting
      for (const key in plotInfo) {
        if (plotInfo[key] === '' || plotInfo[key] === null || plotInfo[key] === undefined) {
          this.$notify({
            title: '警告',
            text: `error: ${key} is empty!`,
            type: 'error',
            duration: 8000
          });
          return;
        }
      }

      try {
        const response = await axios.post('/plots/create', plotInfo);
        console.log(response.data);
        if (response.data.success === false) {
          this.notifyText = response.data.msg;
          this.snackbar = true;
        } else {
          this.notifyText = '添加成功！';
          this.snackbar = true;
          // Clear the input fields
          this.parcelName = '';
          this.ownerName = '';
          this.ownerId = '';
          this.area = '';
          // refresh the trustee lands
          this.$emit('refreshTrusteeLands');
        }
      } catch (error) {
        this.notifyText = '服务器出错！';
        this.snackbar = true;
        console.error(error);
      }
    },

    selectPlot () {
      const hasPersonName = typeof this.personName === 'string'
        ? this.personName.trim().length > 0
        : !!this.personName?.name;

      if (!hasPersonName) {
        this.notifyText = '请选择人员';
        this.snackbar = true;
        return;
      }

      this.searchPlots(this.personName);
    },
    /**
   * Handles the selection of a person from the dropdown
   * @param {Object} selectedPerson - The selected person object
   */
    onPersonSelected (selectedPerson) {
      if (selectedPerson && typeof selectedPerson === 'object' && selectedPerson.name) {
        this.landData = [];
        this.searchPlots(selectedPerson);
      }
    },

    /**
     * Searches for plots based on the provided person's name.
     * @param {string} personName - The name of the person to search plots for.
     * @returns {Promise<void>}
     */
    async searchPlots (person) {
      this.loading = true;
      try {
        const searchName = (typeof person === 'string') ? person : (person?.name || '');
        const searchId = (typeof person === 'object')
          ? (person?.id_number_raw || person?.id_number || null)
          : null;
        const searchIds = (typeof person === 'object' && Array.isArray(person?.search_id_numbers))
          ? person.search_id_numbers.filter(item => String(item || '').trim().length > 0)
          : [];

        const response = await axios.post('/plots/search-by-person', {
          village_code: this.selectedArea?.place_id,
          name: searchName,
          id_number: searchId,
          id_numbers: searchIds
        });

        if (response.data && response.data.data) {
          this.landData = response.data.data.map(item => this.normalizePlot(item));
        } else {
          this.landData = [];
        }
        // Locate the lands if plot data is found
        if (this.landData.length > 0) {
          this.locateLand(this.landData.map(item => item.land_id));
        }
      } catch (error) {
        console.error('查询失败:', error);
        this.notifyText = '查询失败';
        this.snackbar = true;
        this.landData = [];
      } finally {
        this.loading = false;
      }
    },
    /**
     * Opens the policy creation dialog.
     * @returns {void}
     */
    createPolicy () {
      if (this.selected.length === 0) {
        this.notifyText = '请选择地块';
        this.snackbar = true;
        return;
      }
      // 业务规则：打开投保弹窗处理方式默认不选，由用户手动选择。
      this.policyForm = {
        bdh: '',
        holderName: this.personName?.name || '',
        holderId: this.getSelectedPersonId(),
        crop_id: null,
        phone_number: this.personName?.mobile_num || this.personName?.phone_number || '',
        tbmj: '',
        applyMode: '',
        isLargeFarmer: false,
        selectedPolicyId: null
      };
      this.matchedPolicyArea = 0;
      this.matchCandidates = [];
      this.policyDialog = true;
    },

    // Add this method in the methods section
    cancelPolicy () {
      this.policyDialog = false;
    },

    applyMatchedPolicy (match) {
      if (match.bdh) this.policyForm.bdh = match.bdh;
      const matchedAreaRaw = match.tbmj ?? match.insured_area;
      const matchedArea = Number(matchedAreaRaw || 0);
      this.matchedPolicyArea = Number.isFinite(matchedArea) ? matchedArea : 0;
      this.policyForm.tbmj = this.policyForm.applyMode === 'append'
        ? ''
        : String(matchedAreaRaw ?? '');
      if (match.qsrmc) this.policyForm.holderName = match.qsrmc;
      const fullIdCard = (match.id_card || match.nhdm || '').trim();
      if (fullIdCard && !fullIdCard.includes('*')) {
        this.policyForm.holderId = fullIdCard.toUpperCase();
      }
      if (match.phone) this.policyForm.phone_number = match.phone;
      this.policyForm.selectedPolicyId = match.id || null;
      if (match.zwlx) {
        const cropMatch = this.authorizedCrops.find(item => item.value === match.zwlx || item.text === match.zwlx);
        if (cropMatch) {
          this.policyForm.crop_id = cropMatch.value;
        }
      }
    },

    selectMatchedPolicy (item) {
      this.applyMatchedPolicy(item);
      this.matchCandidateDialog = false;
      this.notifyText = `匹配成功，默认处理方式为 default（matched 规则，${this.policyForm.bdh}）`;
      this.snackbar = true;
    },

    async policyConfirm () {
      if (!this.$refs.policyForm.validate()) {
        this.notifyText = '请检查表单是否填写正确';
        this.snackbar = true;
        return;
      }
      const plotIds = this.selected
        .map(plot => plot.land_id)
        .filter(id => id !== null && id !== undefined);

      if (plotIds.length === 0) {
        this.notifyText = '未找到可提交的地块ID';
        this.snackbar = true;
        return;
      }

      const cropText = this.selectedCropText || this.policyForm.crop_id || '';

      if (this.errorRate !== null && Math.abs(this.errorRate) > MAX_AREA_ERROR_RATE_PERCENT) {
        this.notifyText = AREA_DEVIATION_BLOCK_TEMPLATE
          .replace('{rate}', this.errorRate.toFixed(2))
          .replace('{limit}', String(MAX_AREA_ERROR_RATE_PERCENT));
        this.snackbar = true;
        return;
      }

      this.policySubmitting = true;
      try {
        const effectiveApplyMode = this.policyForm.applyMode || (this.hasMatchedPolicy ? 'matched' : '');
        const isEffectiveAppendMode = effectiveApplyMode === 'append';
        const isEffectiveReplaceMode = effectiveApplyMode === 'replace';

        if (!effectiveApplyMode) {
          this.notifyText = '请选择处理方式';
          this.snackbar = true;
          return;
        }

        // 业务规则：default(matched)/追加/替换必须先匹配保单；新增可直接创建新保单号。
        if (effectiveApplyMode !== 'new' && !this.policyForm.selectedPolicyId) {
          this.notifyText = '请先匹配保单';
          this.snackbar = true;
          return;
        }

        const inputArea = Number(this.policyForm.tbmj);
        const submitTotalArea = isEffectiveAppendMode
          ? Number((Number(this.matchedPolicyArea || 0) + inputArea).toFixed(2))
          : inputArea;

        const submitData = {
          village_code: this.selectedArea?.place_id,
          plot_ids: plotIds,
          // default(matched)/新增/追加/替换统一走后端 apply_mode 规则。
          selected_policy_id: this.policyForm.selectedPolicyId,
          replace_existing: isEffectiveReplaceMode,
          apply_mode: effectiveApplyMode,
          delta_tbmj: isEffectiveAppendMode ? inputArea : null,
          bdh: this.policyForm.bdh,
          qsrmc: this.policyForm.holderName,
          nhdm: this.policyForm.holderId,
          phone: this.policyForm.phone_number,
          zwlx: cropText,
          nhlx: this.policyForm.isLargeFarmer ? '1' : '',
          tbmj: submitTotalArea
        };

        const response = await axios.post('/policies/apply', submitData);
        if (response.data) {
          const insuredPlotIds = new Set(plotIds);
          this.landData = this.landData.filter(plot => !insuredPlotIds.has(plot.land_id));
          this.selected = [];
          this.insureApplyStore.clearSelectedLandPlots();
          this.notifyText = response.data.message || '投保提交成功';
          this.snackbar = true;
          this.policyDialog = false;
        } else {
          this.notifyText = '保存失败';
          this.snackbar = true;
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.notifyText = error?.response?.data?.detail || '保存失败';
        this.snackbar = true;
      } finally {
        this.policySubmitting = false;
      }
    },

    async matchPolicyInfo () {
      if (!this.selectedArea?.place_id) {
        this.notifyText = '请先选择区域';
        this.snackbar = true;
        return;
      }

      const holderName = (this.policyForm.holderName || this.personName?.name || '').trim();
      const cropText = (this.selectedCropText || '').trim();
      if (!holderName || !cropText) {
        this.notifyText = '请先填写姓名并选择作物类型';
        this.snackbar = true;
        return;
      }

      this.matchLoading = true;
      try {
        this.policyForm.selectedPolicyId = null;
        this.matchedPolicyArea = 0;
        this.matchCandidates = [];
        const response = await axios.post('/policies/match', {
          village_code: this.selectedArea?.place_id,
          qsrmc: holderName,
          zwlx: cropText,
          bdh: this.policyForm.bdh || ''
        });

        const matches = response.data || [];
        if (matches.length === 1) {
          this.applyMatchedPolicy(matches[0]);
          this.notifyText = `匹配成功，默认处理方式为 default（matched 规则，${this.policyForm.bdh}）`;
          this.snackbar = true;
        } else if (matches.length > 1) {
          this.matchCandidates = matches;
          this.matchCandidateDialog = true;
        } else {
          this.notifyText = '未找到匹配保单';
          this.snackbar = true;
        }
      } catch (error) {
        console.error('匹配失败:', error);
        this.notifyText = '匹配失败';
        this.snackbar = true;
      } finally {
        this.matchLoading = false;
      }
    },

    async refresh () {
      // Implement refresh logic for dependent dropdowns if needed
    },
    async viewSelectedLand (item) {
      // Extract the land ID from a single item and call locateLand with an array containing this ID
      const landId = item.land_id || item.dkbm;
      console.log('查看地块 - 完整数据:', item);
      console.log('查看地块 - 地块ID:', landId);
      console.log('查看地块 - 地图实例:', this.map);

      if (!landId) {
        this.notifyText = '地块ID不存在';
        this.snackbar = true;
        return;
      }

      if (!this.map) {
        this.notifyText = '地图未加载，请稍后重试';
        this.snackbar = true;
        console.error('地图实例未初始化，请等待地图加载完成');
        return;
      }

      await this.locateLand([landId]);
    },
    async locateLand (landIds) {
      const self = this;
      try {
        const seq = ++this.locateSeq;
        const startedAt = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

        if (!landIds || landIds.length === 0) {
          throw new Error('未提供地块ID');
        }

        console.groupCollapsed(`[InsureResult.locateLand] seq=${seq} ids=${landIds.length}`);
        console.log('定位地块IDs:', landIds);

        if (!self.map) {
          console.warn(`[InsureResult.locateLand] seq=${seq} map is not ready`);
          this.notifyText = '地图未加载，请稍后重试';
          this.snackbar = true;
          console.groupEnd();
          return;
        } else {
          const view = self.map.getView();
          const proj = view && view.getProjection ? view.getProjection() : null;
          console.log('map view:', {
            target: self.map.getTarget ? self.map.getTarget() : null,
            targetElementId: self.map.getTargetElement && self.map.getTargetElement() ? self.map.getTargetElement().id : null,
            projection: proj ? (proj.getCode ? proj.getCode() : proj) : null,
            zoom: view && view.getZoom ? view.getZoom() : null,
            center: view && view.getCenter ? view.getCenter() : null,
            resolution: view && view.getResolution ? view.getResolution() : null
          });

          const layers = self.map.getLayers().getArray();
          console.log('layers(total):', layers.length);
          const lidSummary = layers
            .map((l, idx) => ({ idx, lid: l.get('lid'), visible: l.getVisible && l.getVisible(), zIndex: l.getZIndex && l.getZIndex() }))
            .filter(x => x.lid);
          console.log('layers(lid):', lidSummary);

          const tail = layers.slice(Math.max(0, layers.length - 6)).map((l, idx) => {
            const layerIdx = layers.length - Math.min(6, layers.length) + idx;
            return {
              idx: layerIdx,
              type: l && l.constructor ? l.constructor.name : typeof l,
              lid: l.get && l.get('lid'),
              visible: l.getVisible && l.getVisible(),
              zIndex: l.getZIndex && l.getZIndex(),
              className: l.getClassName && l.getClassName()
            };
          });
          console.log('layers(tail):', tail);
        }

        // Clear previous blinking interval early to avoid cross-request visibility flicker
        if (this.blinkTimer) {
          clearInterval(this.blinkTimer);
          this.blinkTimer = null;
        }

        // 使用后端 API 获取地块数据（通过 land_id 过滤）
        const plotRequests = landIds.map(id =>
          axios.get('/plots/', {
            params: {
              land_id: id,
              limit: 1
            }
          })
            .catch(err => {
              console.warn(`获取地块 ${id} 失败:`, err);
              return null;
            })
        );

        const responses = await Promise.all(plotRequests);

        // Map may have been unbound while awaiting requests
        if (!self.map) {
          console.warn(`[InsureResult.locateLand] seq=${seq} map unbound while awaiting requests`);
          this.notifyText = '地图未加载，请稍后重试';
          this.snackbar = true;
          console.groupEnd();
          return;
        }

        // Ignore stale results if a newer locateLand call started while awaiting
        if (seq !== this.locateSeq) {
          console.warn(`[InsureResult.locateLand] seq=${seq} stale after requests; latest=${this.locateSeq}`);
          console.groupEnd();
          return;
        }

        const plots = responses
          .filter(r => r && r.data && r.data.features)
          .flatMap(r => r.data.features);

        console.log('获取到的地块数据:', plots);

        if (!plots || plots.length === 0) {
          this.notifyText = '未找到该地块的地理信息';
          this.snackbar = true;
          return;
        }

        // 后端返回的已经是 GeoJSON Feature 格式
        const featureCollection = {
          type: 'FeatureCollection',
          features: plots.filter(plot => plot.geometry)
        };

        if (featureCollection.features.length === 0) {
          this.notifyText = '地块缺少地理坐标信息';
          this.snackbar = true;
          return;
        }

        // 创建矢量要素
        const format = new GeoJSON();
        // Use map projection ensuring correct coordinate transformation
        const mapProjection = self.map.getView().getProjection();
        const features = featureCollection.features.map(feature => {
          return format.readFeature(feature, {
            dataProjection: 'EPSG:4326',
            featureProjection: mapProjection
          });
        });

        console.log('解析的要素:', features);

        // 更新矢量图层
        this.selectedVectorSource.clear();
        features.forEach(feature => this.selectedVectorSource.addFeature(feature));

        // 获取或创建高亮图层
        let highlightLayer = self.map.getLayers().getArray()
          .find(layer => layer.get('lid') === 'activeParcelLayer');

        if (!highlightLayer) {
          // 如果图层不存在，创建新图层
          highlightLayer = new VectorLayer({
            source: this.selectedVectorSource,
            style: this.polygonStyleFunction,
            zIndex: 999999
          });
          highlightLayer.set('lid', 'activeParcelLayer');
          self.map.addLayer(highlightLayer);
          console.log('创建新的高亮图层');
        } else {
          // 如果图层存在，更新其属性
          highlightLayer.setSource(this.selectedVectorSource);
          highlightLayer.setStyle(this.polygonStyleFunction);
          highlightLayer.setZIndex(999999);
          highlightLayer.setVisible(true);
          console.log('更新现有高亮图层');
        }

        // Force highlight layer to be the top-most layer in collection order.
        // This avoids being covered by a late-added opaque layer/group.
        try {
          self.map.removeLayer(highlightLayer);
          self.map.addLayer(highlightLayer);
          console.log('高亮图层已置顶(重新添加到最上层)');
        } catch (e) {
          console.warn('高亮图层置顶失败:', e);
        }

        // Sanity log for the highlight layer instance and ordering
        try {
          const layersArr = self.map.getLayers().getArray();
          const idx = layersArr.indexOf(highlightLayer);
          const source = highlightLayer && highlightLayer.getSource ? highlightLayer.getSource() : null;
          console.log('highlight layer state:', {
            layerIndex: idx,
            isVectorLayer: !!(highlightLayer && highlightLayer.getSource),
            visible: highlightLayer && highlightLayer.getVisible ? highlightLayer.getVisible() : null,
            zIndex: highlightLayer && highlightLayer.getZIndex ? highlightLayer.getZIndex() : null,
            sourceFeatureCount: source && source.getFeatures ? source.getFeatures().length : null
          });
        } catch (e) {
          console.warn('highlight layer state log failed:', e);
        }

        // 清除之前的闪烁定时器
        if (this.blinkTimer) {
          clearInterval(this.blinkTimer);
          this.blinkTimer = null;
        }

        // 闪烁效果：快速切换可见性
        let blinkCount = 0;
        // Ensure visible before starting
        highlightLayer.setVisible(true);

        this.blinkTimer = setInterval(() => {
          if (highlightLayer) {
            highlightLayer.setVisible(blinkCount % 2 === 0);
            blinkCount++;
            if (blinkCount >= 6) {
              clearInterval(this.blinkTimer);
              this.blinkTimer = null;
              highlightLayer.setVisible(true);
            }
          }
        }, 200);

        // 计算所有地块的总范围
        const extent = this.selectedVectorSource.getExtent();
        console.log('地块范围:', extent);

        // Force map redraw in case other logic toggled rendering recently
        if (this.selectedVectorSource && typeof this.selectedVectorSource.changed === 'function') {
          this.selectedVectorSource.changed();
        }
        if (highlightLayer && typeof highlightLayer.changed === 'function') {
          highlightLayer.changed();
        }
        if (self.map && typeof self.map.render === 'function') {
          self.map.render();
        }

        this.map.getView().fit(extent, {
          padding: [80, 80, 80, 80],
          duration: 1000,
          maxZoom: 17
        });

        const endedAt = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
        console.log(`[InsureResult.locateLand] seq=${seq} done in ${Math.round(endedAt - startedAt)}ms`);
        console.groupEnd();

        // this.notifyText = '地块定位成功';
        // this.snackbar = true;
      } catch (error) {
        console.error('获取地块数据失败:', error);
        this.notifyText = `获取地块信息失败: ${error.message}`;
        this.snackbar = true;

        // Ensure console group is closed even on error
        try {
          console.groupEnd();
        } catch (e) {
          // no-op
        }
      }
    },
    // Update selections when map plots change
    updateSelectedPlotsFromMap () {
      this.selectedLandPlots.forEach(plot => {
        if (this.isInsured(plot)) return;

        const normalized = this.normalizePlot({ ...plot, fromMap: true });
        if (!this.isInCart(normalized)) {
          this.selected.push(normalized);
          this.insureApplyStore.addSelectedLandPlot(normalized);
        }
      });
    },
    goToPlotDraw () {
      this.$emit('request-draw-mode');

      if (this.$route?.name === 'InsureApply') {
        return;
      }

      this.persistInsureApplyState({
        toRoute: '/insure-apply?mode=draw'
      });
      this.$router.push({ path: '/insure-apply', query: { from: 'insure-apply', mode: 'draw' } });
    },
    backToInsureApply () {
      this.$emit('request-search-mode');
    },
    ensureCoordLayer () {
      if (this.coordLayer && this.map) return;

      // Check if layer already exists on map to avoid duplicates
      if (this.map) {
        const layers = this.map.getLayers().getArray();
        const existingLayer = layers.find(l => l.get('lid') === 'insure-result-coord-marker');
        if (existingLayer) {
          this.coordLayer = existingLayer;
          return;
        }
      }

      this.coordLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 9999,
        style: new Style({
          image: new CircleStyle({
            radius: 10,
            fill: new Fill({ color: 'rgba(255, 0, 0, 0.9)' }),
            stroke: new Stroke({ color: '#ffffff', width: 3 })
          })
        })
      });
      this.coordLayer.set('lid', 'insure-result-coord-marker');
      if (this.map) {
        this.map.addLayer(this.coordLayer);
      }
    },
    locateByCoord () {
      if (!this.coordInput || !this.map) {
        return;
      }

      try {
        const parts = this.coordInput.trim().split(/[,，\s]+/);
        if (parts.length < 2) {
          this.notifyText = '请输入正确的经纬度格式（如：118.5,42.3）';
          this.snackbar = true;
          return;
        }

        const lon = parseFloat(parts[0]);
        const lat = parseFloat(parts[1]);

        if (isNaN(lon) || isNaN(lat)) {
          this.notifyText = '经纬度必须是数字';
          this.snackbar = true;
          return;
        }

        console.log(`[Locate] Coordinates input: ${lon}, ${lat}`);

        this.ensureCoordLayer();
        const source = this.coordLayer.getSource();
        source.clear();

        const view = this.map.getView();
        let center = [lon, lat];

        // Auto-detect if we need to transform coordinates
        const projection = view.getProjection();
        if (projection && projection.getCode() === 'EPSG:3857') {
          console.log('[Locate] Transforming EPSG:4326 to EPSG:3857');
          center = fromLonLat([lon, lat]);
        }

        console.log(`[Locate] Final center: ${center}`);

        const feature = new Feature({
          geometry: new Point(center)
        });
        source.addFeature(feature);

        // Zoom to the feature
        view.fit(feature.getGeometry(), {
          padding: [100, 100, 100, 100],
          maxZoom: 16,
          duration: 1000
        });
      } catch (error) {
        console.error('定位失败:', error);
        this.notifyText = '定位失败，请检查坐标格式';
        this.snackbar = true;
      }
    },

    /**
     * Checks if a plot is already insured
     * @param {Object} item - The plot item
     * @returns {boolean} - True if plot is insured
     */
    isInsured (item) {
      return item && (item.bs === '1' || item.bs === 1);
    }
  },
  mounted () {
    this.restoreInsureApplyState();
    // When component is mounted, add any existing map selections to the selected array
    this.updateSelectedPlotsFromMap();
  }
}
</script>

<style scoped>
.measure-result {
  font-size: 14px;
  padding-left: 8px;
  padding-bottom: 8px;
}

.insure-section {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}

.insure-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.insure-section__title {
  font-size: 16px;
  font-weight: 600;
  color: #212121;
}

.centered-snackbar {
  left: 50%;
  top: 4em;
  transform: translate(-50%, -50%);
}

.v-data-table {
  margin-bottom: 10px;
  overflow: hidden;
}

/* 确保表格内容区域可以滚动 */
.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto;
}

/* 减少表格单元格之间的间距 */
.v-data-table ::v-deep td {
  padding: 0 4px !important;
  height: 32px !important;
  font-size: 0.85rem !important;
}

/* 减少表头的间距和高度 */
.v-data-table ::v-deep th {
  padding: 0 4px !important;
  height: 36px !important;
  font-size: 0.875rem !important;
}

/* 减少操作列按钮的大小和间距 */
.v-data-table ::v-deep .v-btn.v-btn--icon.v-size--x-small,
.v-data-table ::v-deep .v-btn.v-size--x-small {
  min-width: 36px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  height: 20px !important;
  font-size: 11px !important;
}

/* 减少操作列中按钮之间的间距 */
.v-data-table ::v-deep .d-flex .mr-2 {
  margin-right: 2px !important;
}

/* 减少表格行高 */
.v-data-table ::v-deep .v-data-table__wrapper table tr {
  min-height: 32px !important;
}

/* 使表格内容更紧凑，移除多余边框间距 */
.v-data-table ::v-deep .v-data-table__wrapper table {
  border-spacing: 0;
  border-collapse: collapse;
}

/* 隐藏复选框列的多余空间 */
.v-data-table ::v-deep .v-data-table__checkbox {
  width: 28px !important;
  padding: 0 2px !important;
}

.info-panel {
  background-color: #e3f2fd;
  border-radius: 4px;
}

/* 已投保状态样式 */
.insured-status {
  color: #1976d2;
  font-weight: 500;
}

/* 按钮样式优化 */
.v-btn.primary {
  background: linear-gradient(135deg, #43A047 0%, #66BB6A 100%) !important;
  box-shadow: 0 2px 8px rgba(67, 160, 71, 0.25) !important;
  border-radius: 6px !important;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-btn.primary:hover {
  box-shadow: 0 4px 12px rgba(67, 160, 71, 0.35) !important;
  transform: translateY(-1px);
}

.v-btn.primary:active {
  transform: translateY(0);
}

.v-btn.v-btn--text {
  font-weight: 500;
  transition: all 0.2s ease;
}

.v-btn.v-btn--text:hover {
  background-color: rgba(67, 160, 71, 0.08) !important;
}

/* 表单元素样式优化 */
.v-text-field.v-input--is-focused fieldset,
.v-select.v-input--is-focused fieldset {
  border-color: #43A047 !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 3px rgba(67, 160, 71, 0.1);
}

.v-text-field:hover fieldset,
.v-select:hover fieldset {
  border-color: #BDBDBD !important;
}

.v-text-field input,
.v-select input {
  font-size: 14px;
  color: #212121;
}

.v-text-field label,
.v-select label {
  font-size: 14px;
  color: #757575;
  font-weight: 500;
}

.policy-row-field-label {
  line-height: 20px;
}

.policy-number-hint-inline {
  line-height: 20px;
  white-space: nowrap;
}

.policy-row-control {
  min-height: 40px;
}

.policy-mode-options {
  padding-top: 2px;
}

.policy-mode-options ::v-deep .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
